/**
 * Navigates the browser to a presigned S3 URL to start a download.
 *
 * Deliberately not a `fetch` + blob: the presigned URL points at the S3 bucket,
 * which has no CORS rule for this origin, so an XHR would be blocked. A plain
 * navigation is not subject to CORS. The signature in the query string is the
 * auth, so no Authorization header is needed (and none can be sent this way).
 */
export function triggerDownload(url: string, filename: string): void {
  const link = document.createElement('a')
  link.href = url
  // Only honoured for same-origin URLs; S3 is cross-origin, so the filename
  // comes from the object key instead. Harmless to set, useful if the report
  // ever moves behind our own domain.
  link.download = filename
  link.rel = 'noopener'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
